import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardImg, CardBody, CardHeader } from 'reactstrap'


const propTypes = {
  imageUrl    : PropTypes.string,
  children    : PropTypes.any,
  noImageText : PropTypes.string
}

const defaultProps = {
  noImageText: 'NO IMAGE'
}

/**
 * Displaying image preview and its image information
 * @param {string} imageUrl - Image Url
 * @param {string} noImageText - Displaying text when image url is not recognized.
 * @param {string} children - Children component
 */
const ImageUploadPreviewCard = ({
  imageUrl,
  noImageText,
  children
}) => {
  const DefaultCover = () => (
    <div
      className='text-uppercase'
      style={{
        width      : '100%',
        color      : 'red',
        minHeight  : '200px',
        lineHeight : '200px',
        textAlign  : 'center'
      }}
    >
      [{ noImageText }]
    </div>
  )

  return (
    <Card>
      <CardHeader>
        <span className='small text-uppercase text-black font-weight-bolder'>
          { 'Image Preview' }
        </span>
      </CardHeader>

      {
        imageUrl
          ? <CardImg src={ imageUrl }/>
          : <DefaultCover/>
      }

      <CardBody>
        { children }
      </CardBody>

    </Card>
  )
}

ImageUploadPreviewCard.propTypes    = propTypes
ImageUploadPreviewCard.defaultProps = defaultProps

export default ImageUploadPreviewCard
